// 成果需求审核状态
const stateList = [
  { name: "全部", value: -1 },
  { name: "未审核", value: 0 },
  // { name: "审核中", value: 3 },
  { name: "已通过", value: 1 },
  { name: "未通过", value: 2 }
];
// 随机生成密码
const generatePassword = () => {
  const charset =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^&*"; // 密码范围
  const length = Math.floor(Math.random() * 11) + 6; // 生成 6 到 16 之间的随机数
  let password = "";
  for (let i = 0; i < length; i++) {
    password += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return password;
};
const pieColors = [
  "#2573D9",
  "#C42A36",
  "#4B9242",
  "#EE902B",
  "#F87797",
  "#C42A36",
  "#595DA6",
  "#4FB4AE",
  "#AD7E6E",
  "#9159A6",
  "#E7C228"
];
export { stateList, generatePassword, pieColors };
